type Props = { title: string; subtitle?: string };
export const CommonTitle = (props: Props) => {
  const { subtitle, title } = props;
  return (
    <>
      <h2 className="text-info text-center ">{title}</h2>
      {subtitle && (
        <p className="h5 d-flex d-flex justify-content-center align-items-center">{subtitle}</p>
      )}
    </>
  );
};
